import { render, staticRenderFns } from "./ProductStatsCards.vue?vue&type=template&id=09d215b8"
import script from "./ProductStatsCards.vue?vue&type=script&lang=js"
export * from "./ProductStatsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports